import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserDetailsService } from '../../../../service/user-details.service';
import { PERMISSION_VIEW_MARKET } from '../../../../service/user-permissions.service';

@Injectable({
  providedIn: 'root'
})
export class CanViewMarketGuard {
  constructor(private readonly userDetailsService: UserDetailsService) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    const permissions = this.userDetailsService.loggedInUser?.permissions ?? [];
    return permissions.filter((p) => p === PERMISSION_VIEW_MARKET).length > 0;
  }
}
